module.exports = __webpack_public_path__ + "img/liushui (2).5e9ff5be.png";